@if (!!users) {
  <div class="bodycontainer audit-log scrollable">
    <opm-grid [metaName]="gridTypeEnum.Audit" [users]="users"></opm-grid>
    <button type="button" class="btn btn-light pull-right" [routerLink]="['/']">Close</button>
  </div>
}
